<template>
    <div>
        <div class="headings" v-if="labelQuiz.length">
            <h4 style="margin: 0 ">Label based quizes:</h4>
        </div>
        <el-table
            v-if="labelQuiz.length"
            class="students-table"
            :border="true"
            :data="labelQuiz"
            style="width: 100%; margin-top: 10px;">
            <el-table-column
                :resizable="false"
                label="Question">
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">Question:</b> {{ scope.row.name }}
                </template>
            </el-table-column>

            <el-table-column
                :resizable="false"
                label="Quiz type">
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">Quiz type:</b> {{ quiztypes[scope.row.type] }}
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                width="100"
                label="Score"
            >
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">Score:</b> <b>{{ scope.row.score }}</b>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                width="100"
                label="User score"
            >
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">User score:</b> <b>{{ scope.row.userScore ? scope.row.userScore : 0 }}</b>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                width="100"
                label="Right answer"
            >
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">Right answer:</b> <b>{{ scope.row.rightAnswer ? scope.row.rightAnswer : "-" }}</b>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                width="100"
                label="User answer"
            >
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">User answer:</b> <b>{{ scope.row.userAnswer ? scope.row.userAnswer : "No answer" }}</b>
                </template>
            </el-table-column>
        </el-table>
        <div class="headings" v-if="slideQuiz.length">
            <h4 style="margin: 0 ">Slide based quizes:</h4>
        </div>
        <el-table
            v-if="slideQuiz.length"
            class="students-table"
            :border="true"
            :data="slideQuiz"
            style="width: 100%; margin-top: 10px;">
            <el-table-column
                :resizable="false"
                label="Question">
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">Question:</b> {{ scope.row.question }}
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="Quiz type">
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">Quiz type:</b> {{ quiztypes[scope.row.type] }}
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                width="100"
                label="Max Score"
            >
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">Max Score:</b> <b>{{ scope.row.score }}</b>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                width="100"
                label="User score"
            >
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">User score:</b> <b>{{ scope.row.userScore ? scope.row.userScore : 0 }}</b>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                width="150"
                label="Correct answer"
            >
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">Correct answer:</b> <b>{{ scope.row.rightAnswer ? scope.row.rightAnswer : "-" }}</b>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                width="150"
                label="User answer"
            >
                <template slot-scope="scope">
                    <b class="hidden-sm-and-up">User answer:</b> <b>{{ scope.row.userAnswer ? scope.row.userAnswer : "No answer" }}</b>
                </template>
            </el-table-column>
            <!--<el-table-column-->
            <!--:resizable="false"-->
            <!--width="100"-->
            <!--prop="correctAnswers"-->
            <!--label="Answers">-->
            <!--<template slot-scope="scope">-->
            <!--<b class="hidden-sm-and-up">Answers:</b> <b>{{ scope.row.correctAnswers }}</b>/{{ scope.row.correctAnswers + scope.row.wrongAnswers }}-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--:resizable="false"-->
            <!--width="100"-->
            <!--prop="time"-->
            <!--label="Time">-->
            <!--<template slot-scope="scope">-->
            <!--<b class="hidden-sm-and-up">Time:</b> {{ Math.floor((scope.row.time/1000/60) << 0) }}:{{ Math.floor((scope.row.time/1000) % 60) }}-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--:resizable="false"-->
            <!--width="100"-->
            <!--prop="createdAt"-->
            <!--label="Date">-->
            <!--<template slot-scope="scope">-->
            <!--<b class="hidden-sm-and-up">Date:</b> {{ scope.row.createdAt.substr(0, 10) }}-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
            <!--width="100"-->
            <!--:resizable="false"-->
            <!--label="Actions">-->
            <!--<template slot-scope="scope">-->
            <!--<el-button-->
            <!--type="primary"-->
            <!--size="mini"-->
            <!--@click="handleView(scope.$index, scope.row)">View</el-button>-->
            <!--</template>-->
            <!--</el-table-column>-->
        </el-table>
    </div>

</template>

<script>
  export default {
    props: {
      result: {
        type: Object,
        default: null,
      },
      labelQuiz: {
        type: Array,
        default: [],
      },
      slideQuiz: {
        type: Array,
        default: [],
      },
    },
    data () {
      return {
        quiztypes: {
          radio: "Select right answer!",
          text: "Fill in the blank!",
          bool: "Choose if true!",
          drag: "Choose the right order!",
          textarea: "Write short answer!",
          select: "Find the parts!",
          isolated: "Name isolated part!",
          draglabels: "Drag labels to right parts!",
          connect: "Connect the parts!",
        },
      }
    },
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/results-table.vue